import { raundColors } from '@/theme/colors'
import { Tabs as MantineTabs } from '@mantine/core'
import type React from 'react'
import styles from './Tabs.module.css'

export type TabsProps = {
  /** タブのラベル配列（2〜3タブを想定） */
  tabs: string[]
  /** アクティブなタブのインデックス（デフォルト: 0） */
  activeIndex?: number
  onChange?: (index: number) => void
  className?: string
  /** タブリストの aria-label */
  ariaLabel?: string
  /** trueの場合、タブリストを横スクロール可能にする（タブ3件以上を想定） */
  scrollable?: boolean
}

export function Tabs({ tabs, activeIndex = 0, onChange, className, ariaLabel, scrollable = false }: TabsProps) {
  return (
    <MantineTabs
      value={String(activeIndex)}
      onChange={(v) => onChange?.(Number(v))}
      style={
        {
          '--tabs-color': raundColors.primary.base,
        } as React.CSSProperties
      }
      classNames={{
        root: `${styles.root} ${className ?? ''}`,
        list: `${styles.list} ${scrollable ? styles.listScrollable : ''}`,
        tab: `${styles.tab} ${scrollable ? styles.tabScrollable : ''}`,
      }}
    >
      <MantineTabs.List aria-label={ariaLabel}>
        {tabs.map((label, i) => (
          <MantineTabs.Tab key={label} value={String(i)}>
            {label}
          </MantineTabs.Tab>
        ))}
      </MantineTabs.List>
    </MantineTabs>
  )
}
